// extracted by mini-css-extract-plugin
export default {"black":"chips_black__c99zy"};